var map = {
	"./decidim/avatar-multiuser.png": 43841,
	"./decidim/brands/facebook.svg": 70213,
	"./decidim/brands/google.svg": 64972,
	"./decidim/brands/twitter-x.svg": 80729,
	"./decidim/cc-badge.png": 11431,
	"./decidim/decidim-logo.svg": 50099,
	"./decidim/default-avatar.svg": 60231,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 36381,
	"./decidim/icons.svg": 94790,
	"./decidim/pattern.png": 38085,
	"./decidim/placeholder-card-g.svg": 71530,
	"./decidim/placeholder-card-l.svg": 63489,
	"./decidim/placeholder.jpg": 45888,
	"./decidim/remixicon.symbol.svg": 48018,
	"./decidim/vendor/social-share-button/douban.svg": 51669,
	"./decidim/vendor/social-share-button/email.svg": 84054,
	"./decidim/vendor/social-share-button/facebook.svg": 87070,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 75314,
	"./decidim/vendor/social-share-button/hacker_news.svg": 2646,
	"./decidim/vendor/social-share-button/linkedin.svg": 67596,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 4997,
	"./decidim/vendor/social-share-button/pinterest.svg": 74032,
	"./decidim/vendor/social-share-button/reddit.svg": 9194,
	"./decidim/vendor/social-share-button/telegram.svg": 97499,
	"./decidim/vendor/social-share-button/tumblr.svg": 98168,
	"./decidim/vendor/social-share-button/twitter.svg": 59,
	"./decidim/vendor/social-share-button/vkontakte.svg": 30865,
	"./decidim/vendor/social-share-button/wechat.svg": 94500,
	"./decidim/vendor/social-share-button/whatsapp.svg": 66876,
	"./decidim/vendor/social-share-button/x.svg": 94558,
	"./decidim/vendor/social-share-button/xing.svg": 66618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99228;